const formatter = new Intl.NumberFormat('en-au', { style: 'currency', currency: 'AUD' })

export function CurrencyFormatter(amount: number): string {
  return formatter.format(amount)
}